import React, { useState, useEffect } from 'react';
import { FaSearch, FaPlus, FaEdit, FaTrash, FaSave, FaTimes } from 'react-icons/fa';
import './Contribuintes.css';

import API_BASE_URL from '../../../../config/api';

const Contribuintes = () => {
  const [contribuintes, setContribuintes] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [editingContribuinte, setEditingContribuinte] = useState(null);
  const [activeTab, setActiveTab] = useState('dados-cadastrais');
  const [loading, setLoading] = useState(false);
  const [searchingCnpj, setSearchingCnpj] = useState(false);
  
  // Estado inicial do formulário mapeado para a estrutura visual desejada
  const [formData, setFormData] = useState({
    // Dados Cadastrais
    tipo_contribuinte: '',
    cnpj_cpf: '', 
    inscricao_mun: '', 
    inscricao_est: '', 
    dnpm: '', 
    situacao_cadastral: 'ativo',
    nm_contribuinte: '', 
    nm_fantasia: '', 
    
    // Dados do(s) Sócio(s)
    socios: [
      {
        nome: '',
        cpf: '',
        rg: '',
        orgao_expedidor: '',
        telefone: '', 
        sexo: 'M' 
      }
    ],

    // Atividade Principal
    subclasse: '', 
    secao: '',
    divisao: '',
    grupo: '',
    classe: '',
    digito: '',
    referencia: '',
    modalidade: 'basico',
    
    // Dados do Empreendimento
    capital: '',
    area_total: '',
    area_construida: '',
    area_utilizada: '',
    
    // Outros
    email1: '',
    email2: '',
    site: '',
    telefone: '',
    cep: '',
    logradouro: '',
    numero: '',
    complemento: '',
    id_bairro: '',
    id_cidade: '',
    uf: '',
    quadra: '',
    id_tplogradouro: ''
  });

  useEffect(() => {
    fetchContribuintes();
  }, []);

  const fetchContribuintes = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}/contribuintes`);
      if (!response.ok) throw new Error('Erro ao buscar contribuintes');
      const data = await response.json();
      setContribuintes(data);
    } catch (error) {
      console.error('Erro:', error);
      alert('Erro ao carregar contribuintes');
    } finally {
      setLoading(false);
    }
  };

  const filteredContribuintes = contribuintes.filter(contribuinte => {
    const term = searchTerm.toLowerCase();
    return (
      (contribuinte.nm_contribuinte && contribuinte.nm_contribuinte.toLowerCase().includes(term)) ||
      (contribuinte.nm_fantasia && contribuinte.nm_fantasia.toLowerCase().includes(term)) ||
      (contribuinte.cnpj_cpf && contribuinte.cnpj_cpf.includes(term)) ||
      (contribuinte.inscricao_mun && contribuinte.inscricao_mun.includes(term))
    );
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Preparar dados para o backend (apenas colunas existentes no banco)
    const payload = {
      tipo_contribuinte: formData.tipo_contribuinte,
      cnpj_cpf: formData.cnpj_cpf ? formData.cnpj_cpf.slice(0, 20) : '',
      inscricao_mun: formData.inscricao_mun ? formData.inscricao_mun.slice(0, 15) : '',
      inscricao_est: formData.inscricao_est ? formData.inscricao_est.slice(0, 15) : '',
      dnpm: formData.dnpm ? formData.dnpm.slice(0, 50) : '',
      situacao_cadastral: formData.situacao_cadastral ? formData.situacao_cadastral.slice(0, 10) : 'ativo',
      nm_contribuinte: formData.nm_contribuinte ? formData.nm_contribuinte.slice(0, 70) : '',
      nm_fantasia: formData.nm_fantasia ? formData.nm_fantasia.slice(0, 50) : '',
      subclasse: formData.subclasse ? formData.subclasse.slice(0, 12) : '',
      
      // Mapear sócios do array para colunas planas
      socio_administrador1: (formData.socios[0]?.nome || '').slice(0, 50),
      cpf_socio1: (formData.socios[0]?.cpf || '').slice(0, 15),
      rg_socio1: (formData.socios[0]?.rg || '').slice(0, 10),
      orgao_socio1: (formData.socios[0]?.orgao_expedidor || '').slice(0, 10),
      celular_socio1: (formData.socios[0]?.telefone || '').slice(0, 15),
      sexo_socio1: formData.socios[0]?.sexo || '',
      
      // Limpar sócio 2 (apenas sócio principal é usado)
      socio_administrador2: '',
      cpf_socio2: '',
      rg_socio2: '',
      orgao_socio2: '',
      celular_socio2: '',
      sexo_socio2: '',
      
      // Contatos
      telefone: formData.telefone ? formData.telefone.slice(0, 15) : '',
      email1: formData.email1 ? formData.email1.slice(0, 50) : '',
      email2: formData.email2 ? formData.email2.slice(0, 50) : '',
      site: formData.site ? formData.site.slice(0, 50) : '',
      
      // Endereço
      cep: formData.cep ? formData.cep.slice(0, 10) : '',
      logradouro: formData.logradouro ? formData.logradouro.slice(0, 50) : '',
      numero: formData.numero ? formData.numero.slice(0, 10) : '',
      complemento: formData.complemento ? formData.complemento.slice(0, 50) : '',
      id_bairro: formData.id_bairro || 0,
      id_cidade: formData.id_cidade || 0,
      uf: formData.uf ? formData.uf.slice(0, 2) : '',
      quadra: formData.quadra ? formData.quadra.slice(0, 10) : '',
      id_tplogradouro: formData.id_tplogradouro || null,
      
      // Campos adicionados recentemente
      capital: formData.capital || null,
      area_total: formData.area_total || null,
      area_construida: formData.area_construida || null,
      area_utilizada: formData.area_utilizada || null,
      modalidade: formData.modalidade || 'basico',
      secao: formData.secao || '',
      divisao: formData.divisao || '',
      grupo: formData.grupo || '',
      classe: formData.classe || '',
      digito: formData.digito || '',
      referencia: formData.referencia || ''
    };

    try {
      const url = editingContribuinte 
        ? `${API_BASE_URL}/contribuintes/${editingContribuinte.id_contribuinte}`
        : `${API_BASE_URL}/contribuintes`;
      
      const method = editingContribuinte ? 'PUT' : 'POST';

      const response = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      if (!response.ok) throw new Error('Erro ao salvar');

      await fetchContribuintes();
      resetForm();
    } catch (error) {
      console.error('Erro ao salvar:', error);
      alert('Erro ao salvar contribuinte');
    }
  };

  const resetForm = () => {
    setFormData({
      tipo_contribuinte: '',
      cnpj_cpf: '',
      inscricao_mun: '',
      inscricao_est: '',
      dnpm: '',
      situacao_cadastral: 'ativo',
      nm_contribuinte: '',
      nm_fantasia: '',
      socios: [
        {
          nome: '',
          cpf: '',
          rg: '',
          orgao_expedidor: '',
          telefone: '',
          sexo: 'M'
        }
      ],
      subclasse: '',
      secao: '',
      divisao: '',
      grupo: '',
      classe: '',
      digito: '',
      referencia: '',
      modalidade: 'basico',
      capital: '',
      area_total: '',
      area_construida: '',
      area_utilizada: '',
      email1: '',
      email2: '',
      site: '',
      telefone: '',
      cep: '',
      logradouro: '',
      numero: '',
      complemento: '',
      id_bairro: '',
      id_cidade: '',
      uf: '',
      quadra: '',
      id_tplogradouro: ''
    });
    setEditingContribuinte(null);
    setShowForm(false);
    setActiveTab('dados-cadastrais');
  };

  const handleEdit = (contribuinte) => {
    // Reconstruir o array de sócios a partir das colunas planas (apenas o principal)
    const socios = [];
    if (contribuinte.socio_administrador1) {
      socios.push({
        nome: contribuinte.socio_administrador1,
        cpf: contribuinte.cpf_socio1,
        rg: contribuinte.rg_socio1,
        orgao_expedidor: contribuinte.orgao_socio1,
        telefone: contribuinte.celular_socio1,
        sexo: contribuinte.sexo_socio1
      });
    } else {
        socios.push({ nome: '', cpf: '', rg: '', orgao_expedidor: '', telefone: '', sexo: 'M' });
    }

    setFormData({
      ...contribuinte,
      socios,
      // Garantir que campos nulos venham como string vazia ou valor padrão
      dnpm: contribuinte.dnpm || '', 
      secao: contribuinte.secao || '',
      divisao: contribuinte.divisao || '',
      grupo: contribuinte.grupo || '',
      classe: contribuinte.classe || '',
      digito: contribuinte.digito || '',
      referencia: contribuinte.referencia || '',
      modalidade: contribuinte.modalidade || 'basico',
      capital: contribuinte.capital || '',
      area_total: contribuinte.area_total || '',
      area_construida: contribuinte.area_construida || '',
      area_utilizada: contribuinte.area_utilizada || ''
    });
    setEditingContribuinte(contribuinte);
    setShowForm(true);
    setActiveTab('dados-cadastrais');
  };

  const handleDelete = async (id) => {
    if (window.confirm('Tem certeza que deseja excluir este contribuinte?')) {
      try {
        const response = await fetch(`${API_BASE_URL}/contribuintes/${id}`, {
          method: 'DELETE'
        });
        if (!response.ok) throw new Error('Erro ao excluir');
        setContribuintes(contribuintes.filter(c => c.id_contribuinte !== id));
      } catch (error) {
        console.error('Erro:', error);
        alert('Erro ao excluir contribuinte');
      }
    }
  };

  const updateSocio = (index, field, value) => {
    const newSocios = [...formData.socios];
    newSocios[index] = { ...newSocios[index], [field]: value };
    setFormData({ ...formData, socios: newSocios });
  };

  const handleSearchCnpj = async () => {
    const cnpj = formData.cnpj_cpf.replace(/[^\d]/g, '');
    if (cnpj.length !== 14) {
      alert('Por favor, digite um CNPJ válido (14 dígitos) para pesquisar.');
      return;
    }

    setSearchingCnpj(true);
    try {
      const response = await fetch(`${API_BASE_URL}/cnpj/${cnpj}`);
      if (!response.ok) {
        const err = await response.json();
        throw new Error(err.error || 'Erro ao buscar CNPJ');
      }
      const data = await response.json();

      // Mapear dados
      const newFormData = { ...formData };
      
      newFormData.tipo_contribuinte = 'J'; // CNPJ é sempre Jurídica
      newFormData.nm_contribuinte = data.nome || '';
      newFormData.nm_fantasia = data.fantasia || '';
      newFormData.email1 = data.email || '';
      
      // Extrair primeiro telefone se houver múltiplos
      if (data.telefone) {
          const tels = data.telefone.split('/');
          newFormData.telefone = tels[0].trim();
      } else {
          newFormData.telefone = '';
      }
      
      // Endereço
      newFormData.logradouro = data.logradouro || '';
      newFormData.numero = data.numero || '';
      newFormData.complemento = data.complemento || '';
      newFormData.cep = data.cep ? data.cep.replace(/[^\d]/g, '') : '';
      newFormData.uf = data.uf || '';
      
      // Atividade Principal
      if (data.atividade_principal && data.atividade_principal.length > 0) {
        const code = data.atividade_principal[0].code;
        newFormData.subclasse = code.slice(0, 12);
      }

      // Sócios
      if (data.qsa && Array.isArray(data.qsa) && data.qsa.length > 0) {
        const socio = data.qsa[0];
        newFormData.socios = [{
            nome: socio.nome,
            cpf: '', 
            rg: '',
            orgao_expedidor: '',
            telefone: '',
            sexo: 'M'
        }];
      }
      
      // Situação
      if (data.situacao) {
          const sit = data.situacao.toUpperCase();
          if (sit === 'ATIVA') newFormData.situacao_cadastral = 'ativo';
          else if (sit === 'BAIXADA' || sit === 'NULA' || sit === 'INAPTA') newFormData.situacao_cadastral = 'inativo';
          else if (sit === 'SUSPENSA') newFormData.situacao_cadastral = 'suspenso';
      }

      setFormData(newFormData);
      alert('Dados do CNPJ carregados com sucesso!');

    } catch (error) {
      console.error(error);
      alert('Erro ao buscar dados do CNPJ: ' + error.message);
    } finally {
      setSearchingCnpj(false);
    }
  };

  return (
    <div className="tabela-referencia-container">
      {!showForm ? (
        <>
          <div className="tabela-header">
            <div className="header-content">
              <h1>Contribuintes</h1>
            </div>
            <button 
              className="btn-primary"
              onClick={() => setShowForm(true)}
            >
              <FaPlus /> Novo Contribuinte
            </button>
          </div>

          <div className="table-container">
            <div className="table-controls">
              <div className="search-container">
                <FaSearch />
                <input
                  type="text"
                  placeholder="Buscar por razão social, nome fantasia, CNPJ..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
              <div className="table-info">
                {filteredContribuintes.length} registros encontrados
              </div>
            </div>

            <div className="table-wrapper">
              <table className="data-table contribuintes-table">
                <thead>
                  <tr>
                    <th className="col-id">ID</th>
                    <th className="col-sigla">Tipo</th>
                    <th className="col-nome">CNPJ/CPF</th>
                    <th className="col-nome">Razão Social</th>
                    <th className="col-nome">Nome Fantasia</th>
                    <th className="col-status">Situação</th>
                    <th className="col-acoes">Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr><td colSpan="7" style={{textAlign: 'center', padding: '20px'}}>Carregando...</td></tr>
                  ) : filteredContribuintes.length === 0 ? (
                    <tr><td colSpan="7" style={{textAlign: 'center', padding: '20px'}}>Nenhum registro encontrado</td></tr>
                  ) : (
                    filteredContribuintes.map(contribuinte => (
                      <tr key={contribuinte.id_contribuinte}>
                        <td>{contribuinte.id_contribuinte}</td>
                        <td>{contribuinte.tipo_contribuinte}</td>
                        <td>{contribuinte.cnpj_cpf}</td>
                        <td>{contribuinte.nm_contribuinte}</td>
                        <td>{contribuinte.nm_fantasia}</td>
                        <td>
                          <span className={`status-badge ${contribuinte.situacao_cadastral}`}>
                            {contribuinte.situacao_cadastral}
                          </span>
                        </td>
                        <td className="col-acoes">
                          <div className="action-buttons">
                            <button 
                              className="btn-edit"
                              onClick={() => handleEdit(contribuinte)}
                              title="Editar"
                            >
                              <FaEdit />
                            </button>
                            <button 
                              className="btn-delete"
                              onClick={() => handleDelete(contribuinte.id_contribuinte)}
                              title="Excluir"
                            >
                              <FaTrash />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </>
      ) : (
        <div className="form-container inline-form">
          <div className="form-header">
            <h2>{editingContribuinte ? 'Editar Contribuinte' : 'Novo Contribuinte'}</h2>
          </div>
          
          <div className="tabs-container">
            <div className="tabs-header">
              <button 
                className={`tab-button ${activeTab === 'dados-cadastrais' ? 'active' : ''}`}
                onClick={() => setActiveTab('dados-cadastrais')}
              >
                Dados Cadastrais
              </button>
              <button 
                className={`tab-button ${activeTab === 'dados-socios' ? 'active' : ''}`}
                onClick={() => setActiveTab('dados-socios')}
              >
                Dados do(s) Sócio(s)
              </button>
              <button 
                className={`tab-button ${activeTab === 'atividade-principal' ? 'active' : ''}`}
                onClick={() => setActiveTab('atividade-principal')}
              >
                Atividade Principal
              </button>
              <button 
                className={`tab-button ${activeTab === 'dados-empreendimento' ? 'active' : ''}`}
                onClick={() => setActiveTab('dados-empreendimento')}
              >
                Dados do Empreendimento
              </button>
            </div>

            <form onSubmit={handleSubmit} className="form-content">
              {activeTab === 'dados-cadastrais' && (
                <>
                  <div className="form-row-3">
                    <div className="form-group">
                      <label>Tipo Contribuinte</label>
                      <select
                        value={formData.tipo_contribuinte}
                        onChange={(e) => setFormData({...formData, tipo_contribuinte: e.target.value})}
                      >
                        <option value="">Selecione...</option>
                        <option value="F">Física</option>
                        <option value="J">Jurídica</option>
                      </select>
                    </div>
                    <div className="form-group">
                      <label>CNPJ / CPF</label>
                      <div className="input-group">
                        <input
                          type="text"
                          value={formData.cnpj_cpf}
                          onChange={(e) => setFormData({...formData, cnpj_cpf: e.target.value})}
                          placeholder="Digite apenas números"
                        />
                        <button 
                          type="button" 
                          className="btn-search"
                          onClick={handleSearchCnpj}
                          disabled={searchingCnpj}
                          title="Buscar dados na Receita"
                        >
                          <FaSearch />
                        </button>
                      </div>
                    </div>
                    <div className="form-group">
                      <label>Situação Cadastral</label>
                      <select
                        value={formData.situacao_cadastral}
                        onChange={(e) => setFormData({...formData, situacao_cadastral: e.target.value})}
                      >
                        <option value="ativo">Ativo</option>
                        <option value="inativo">Inativo</option>
                        <option value="suspenso">Suspenso</option>
                      </select>
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <label>Razão Social / Nome</label>
                      <input
                        type="text"
                        value={formData.nm_contribuinte}
                        onChange={(e) => setFormData({...formData, nm_contribuinte: e.target.value})}
                      />
                    </div>
                    <div className="form-group">
                      <label>Nome Fantasia</label>
                      <input
                        type="text"
                        value={formData.nm_fantasia}
                        onChange={(e) => setFormData({...formData, nm_fantasia: e.target.value})}
                      />
                    </div>
                  </div>

                  <div className="form-row-3">
                    <div className="form-group">
                      <label>Inscrição Municipal</label>
                      <input
                        type="text"
                        value={formData.inscricao_mun}
                        onChange={(e) => setFormData({...formData, inscricao_mun: e.target.value})}
                      />
                    </div>
                    <div className="form-group">
                      <label>Inscrição Estadual</label>
                      <input
                        type="text"
                        value={formData.inscricao_est}
                        onChange={(e) => setFormData({...formData, inscricao_est: e.target.value})}
                      />
                    </div>
                    <div className="form-group">
                      <label>DNPM</label>
                      <input
                        type="text"
                        value={formData.dnpm}
                        onChange={(e) => setFormData({...formData, dnpm: e.target.value})}
                      />
                    </div>
                  </div>

                  <div className="form-row-3">
                    <div className="form-group">
                      <label>Telefone</label>
                      <input
                        type="text"
                        value={formData.telefone}
                        onChange={(e) => setFormData({...formData, telefone: e.target.value})}
                      />
                    </div>
                    <div className="form-group">
                      <label>Email Principal</label>
                      <input
                        type="email"
                        value={formData.email1}
                        onChange={(e) => setFormData({...formData, email1: e.target.value})}
                      />
                    </div>
                    <div className="form-group">
                      <label>Site</label>
                      <input
                        type="text"
                        value={formData.site}
                        onChange={(e) => setFormData({...formData, site: e.target.value})}
                      />
                    </div>
                  </div>

                  <h4>Endereço</h4>
                  <div className="form-row-3">
                    <div className="form-group">
                      <label>CEP</label>
                      <input
                        type="text"
                        value={formData.cep}
                        onChange={(e) => setFormData({...formData, cep: e.target.value})}
                      />
                    </div>
                    <div className="form-group">
                      <label>Logradouro</label>
                      <input
                        type="text"
                        value={formData.logradouro}
                        onChange={(e) => setFormData({...formData, logradouro: e.target.value})}
                      />
                    </div>
                    <div className="form-group">
                      <label>Número</label>
                      <input
                        type="text"
                        value={formData.numero}
                        onChange={(e) => setFormData({...formData, numero: e.target.value})}
                      />
                    </div>
                  </div>
                  <div className="form-row-3">
                    <div className="form-group">
                      <label>Complemento</label>
                      <input
                        type="text"
                        value={formData.complemento}
                        onChange={(e) => setFormData({...formData, complemento: e.target.value})}
                      />
                    </div>
                    <div className="form-group">
                      <label>Bairro (ID)</label>
                      <input
                        type="number"
                        value={formData.id_bairro}
                        onChange={(e) => setFormData({...formData, id_bairro: e.target.value})}
                      />
                    </div>
                    <div className="form-group">
                      <label>Cidade (ID)</label>
                      <input
                        type="number"
                        value={formData.id_cidade}
                        onChange={(e) => setFormData({...formData, id_cidade: e.target.value})}
                      />
                    </div>
                  </div>
                </>
              )}

              {activeTab === 'dados-socios' && (
                <>
                  {formData.socios.map((socio, index) => (
                    <div key={index} className="socio-card">
                      <h4>Sócio Administrador</h4>
                      <div className="form-row-3">
                        <div className="form-group">
                          <label>Nome</label>
                          <input
                            type="text"
                            value={socio.nome}
                            onChange={(e) => updateSocio(index, 'nome', e.target.value)}
                          />
                        </div>
                        <div className="form-group">
                          <label>CPF</label>
                          <input
                            type="text"
                            value={socio.cpf}
                            onChange={(e) => updateSocio(index, 'cpf', e.target.value)}
                          />
                        </div>
                        <div className="form-group">
                          <label>RG</label>
                          <input
                            type="text"
                            value={socio.rg}
                            onChange={(e) => updateSocio(index, 'rg', e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="form-row-3">
                        <div className="form-group">
                          <label>Órgão Exp.</label>
                          <input
                            type="text"
                            value={socio.orgao_expedidor}
                            onChange={(e) => updateSocio(index, 'orgao_expedidor', e.target.value)}
                          />
                        </div>
                        <div className="form-group">
                          <label>Telefone/Celular</label>
                          <input
                            type="text"
                            value={socio.telefone}
                            onChange={(e) => updateSocio(index, 'telefone', e.target.value)}
                          />
                        </div>
                        <div className="form-group">
                          <label>Sexo</label>
                          <select
                            value={socio.sexo}
                            onChange={(e) => updateSocio(index, 'sexo', e.target.value)}
                          >
                            <option value="M">Masculino</option>
                            <option value="F">Feminino</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  ))}
                </>
              )}

              {activeTab === 'atividade-principal' && (
                <>
                  <div className="form-row">
                    <div className="form-group">
                      <label>Código Subclasse (CNAE)</label>
                      <input
                        type="text"
                        value={formData.subclasse}
                        onChange={(e) => setFormData({...formData, subclasse: e.target.value})}
                        placeholder="Ex: 4711302"
                      />
                    </div>
                    <div className="form-group">
                      <label>Modalidade</label>
                      <select
                        value={formData.modalidade}
                        onChange={(e) => setFormData({...formData, modalidade: e.target.value})}
                      >
                        <option value="basico">Básico</option>
                        <option value="simplificado">Simplificado</option>
                        <option value="completo">Completo</option>
                      </select>
                    </div>
                  </div>
                  {/* Outros campos de CNAE poderiam ser preenchidos automaticamente se tivéssemos a tabela CNAE linkada aqui */}
                </>
              )}

              {activeTab === 'dados-empreendimento' && (
                <>
                  <div className="form-row-3">
                    <div className="form-group">
                      <label>Capital Social</label>
                      <input
                        type="text"
                        value={formData.capital}
                        onChange={(e) => setFormData({...formData, capital: e.target.value})}
                      />
                    </div>
                    <div className="form-group">
                      <label>Área Total</label>
                      <input
                        type="text"
                        value={formData.area_total}
                        onChange={(e) => setFormData({...formData, area_total: e.target.value})}
                      />
                    </div>
                    <div className="form-group">
                      <label>Área Construída</label>
                      <input
                        type="text"
                        value={formData.area_construida}
                        onChange={(e) => setFormData({...formData, area_construida: e.target.value})}
                      />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group">
                      <label>Área Utilizada</label>
                      <input
                        type="text"
                        value={formData.area_utilizada}
                        onChange={(e) => setFormData({...formData, area_utilizada: e.target.value})}
                      />
                    </div>
                  </div>
                </>
              )}

              <div className="form-actions">
                <button type="button" className="btn-secondary" onClick={resetForm}>
                  <FaTimes /> Cancelar
                </button>
                <button type="submit" className="btn-primary">
                  <FaSave /> Salvar
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Contribuintes;
